import React from 'react';
import {
  List, ListItem, ListItemText, Paper, Select, MenuItem, FormControl,
  Typography, useMediaQuery, useTheme,
} from '@material-ui/core';

// Section list for the Settings page.
//
// A vertical nav rather than tabs: there are enough sections that tab labels
// would wrap or scroll, and keeping every label visible makes the page's shape
// obvious. Below `md` it collapses to a single Select — a sidebar on a phone
// would eat most of the screen before any setting appeared.
const SettingsNav = ({ sections, active, onChange }) => {
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('sm'));

  if (compact) {
    return (
      <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 16 }}>
        <Select value={active} onChange={(e) => onChange(e.target.value)}>
          {sections.map((s) => (
            <MenuItem key={s.id} value={s.id}>{s.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <Paper elevation={5} style={{ position: 'sticky', top: 16, overflow: 'hidden' }}>
      {/* Same header treatment as the cards on the right, so the nav reads as a
          peer of the panel it controls rather than as chrome around it. */}
      <Typography variant="h4" className="header-text">
        Settings
      </Typography>
      <List component="nav" disablePadding>
        {sections.map((s) => {
          const selected = s.id === active;
          return (
            <ListItem
              button
              key={s.id}
              id={s.tourId}
              selected={selected}
              onClick={() => onChange(s.id)}
              style={{
                // A left bar rather than a fill: the panels to the right are
                // already white cards, so a heavy selected row competes with them.
                borderLeft: `4px solid ${selected ? '#FF682C' : 'transparent'}`,
                backgroundColor: selected ? '#00000008' : 'transparent',
              }}
            >
              <ListItemText
                primary={s.label}
                secondary={s.hint}
                primaryTypographyProps={{
                  style: { fontWeight: selected ? 700 : 400, fontSize: '0.95rem' },
                }}
                secondaryTypographyProps={{ style: { fontSize: '0.72rem' } }}
              />
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
};

export default SettingsNav;
